@let colorFamily = family();

@if (entries().length > 0) {
    <div
        [class]="'stats-grid stats-' + resolvedStyle()"
        [style.--stats-cols]="resolvedColumns()"
        [style.--stats-number]="colorFamily.statNumber"
        [style.--stats-ink]="colorFamily.statInk"
        [style.--stats-fill]="colorFamily.fill"
        [style.--stats-line]="colorFamily.statLine">
        @for (entry of entries(); track $index) {
            <div class="stat">
                @if (entry.value.trim()) {
                    <p class="stat-value">{{ entry.value.trim() }}</p>
                }
                @if (entry.label.trim()) {
                    <p class="stat-label">{{ entry.label.trim() }}</p>
                }
            </div>
        }
    </div>
}
